import React, { useState, useEffect, useCallback } from 'react';
import {
	Card,
	TranslatedString,
	useAjax,
	XhrStatus,
	PrimaryButton
} from '@bosch/bt-ui';

import './QueryVPNInfoPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import { prepareLogData } from '../../components/Util';

const QueryVPNInfoPage = (props) => {
	const {
		subTask,
		setSubTask,
		token,
		formValues,
		runAjax,
		returnObj
	} = props;

	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);
	const [returnInnerObj, setReturnInnerObj] = useState(null);
	const [disableCheck, setCheckDisable] = useState(true);
	const tier3NetworkName = "Tier3 Standard";

	const onFormSubmit = useCallback(
        () => {

			const data = prepareLogData(token,'SIM_Management', 'Fetch SIMs VPN Information-> Query: ' + formValues.SimId);

			setSubTask('QueryVPNInfoPage');
			runAjax('GET', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/querydevice/' + formValues.SimId, null, undefined, { 'Authorization': 'Bearer ' + token.token });
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
        },
        [formValues]
    );

	const onCheckOnline = useCallback(
        () => {
			const headers = {
				'Authorization': 'Bearer ' + token.token
			}
			const data = prepareLogData(token,'SIM_Management', ' Fetch SIMs VPN Information-> Check: ' + formValues.SimId);
			runAjaxInner('GET', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/querydevicenetworkstatus/' + formValues.SimId, null, undefined, { 'Authorization': 'Bearer ' + token.token });
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
        },
        [token,formValues,runAjaxInner]
    );

	useEffect(() => {
		console.log('QueryVPNInfoPage==========>')
		console.log(response)
		console.log(returnResult)

		setReturnInnerObj(returnResult);
    }, [returnResult]);

	useEffect(() => {
		(subTask == "QueryVPNInfoPage" && returnObj?.status == "Success") ? setCheckDisable(false) : setCheckDisable(true);
		setReturnInnerObj(null);
    }, [formValues, returnObj]);

	return (
		<Card
			htmlAttributes={{
				id: "query-vpn",
				className: 'query-vpn-info-page'
			}}
		>
			<div className="caption font-large"><TranslatedString stringId="caption-query-vpn" /></div>
			<div className="query-vpn-body">
				<div className="sim-input-field">{formValues.SimId}</div>
				<div className="query-vpn-submit">
					<PrimaryButton type="button" onClick={onFormSubmit}>
						<TranslatedString stringId="button-query" />
					</PrimaryButton>
				</div>
				<div className="device-status">
					<div><TranslatedString stringId="query-vpn-check-online" /></div>
					<PrimaryButton type="button" onClick={onCheckOnline} disabled={disableCheck}>
						<TranslatedString stringId="button-check" />
					</PrimaryButton>
					<div className="online font-large">{returnInnerObj?.data?.OnlineStatus}</div>
				</div>
				{subTask == "QueryVPNInfoPage" && returnObj?.data && (
				<div className="device-info">
					<div className="device-info-block">
					    <div className="device-info-title"><TranslatedString stringId="query-vpn-networkmodelname" /></div>
						<div className="device-info-cell">
							{!returnObj?.data?.hasOwnProperty("networkModelName") || returnObj?.data?.networkModelName === "" || !returnObj?.data?.networkModelName ?<span className="network-model-warning"> <TranslatedString stringId="dialog-error" /> </span>: returnObj?.data?.networkModelName} 
							{returnObj?.data?.hasOwnProperty("networkModelName") && returnObj?.data?.networkModelName !== "" && returnObj?.data?.networkModelName && returnObj?.data?.networkModelName !== tier3NetworkName && <span className="network-model-warning"> (<TranslatedString stringId="query-t2-vpn-warning" />)</span>}</div>
						{returnObj?.data?.networkModelName === tier3NetworkName && <React.Fragment>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-vpngateway" /></div>
						<div className="device-info-cell">{returnObj?.data?.vpnGateway}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-vpnusername" /></div>
						<div className="device-info-cell">{returnObj?.data?.vpnUserName}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-vpnpassword" /></div>
						<div className="device-info-cell">{returnObj?.data?.vpnPassword}</div></React.Fragment>}
					</div>
					<div className="device-info-block">
						<div className="device-info-title"><TranslatedString stringId="query-vpn-ipaddress" /></div>
						<div className="device-info-cell">{returnObj?.data?.ipAddress}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-phonenumber" /></div>
						<div className="device-info-cell">{returnObj?.data?.phoneNumber}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-devicestatus" /></div>
						<div className="device-info-cell">{returnObj?.data?.deviceStatus}</div>
					</div>
					<div className="device-info-block">
						<div className="device-info-title"><TranslatedString stringId="query-vpn-vendorcode" /></div>
						<div className="device-info-cell">{returnObj?.data?.vendorCode}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-imei" /></div>
						<div className="device-info-cell">{returnObj?.data?.imei}</div>
						<div className="device-info-title"><TranslatedString stringId="query-vpn-laststatus" /></div>
						<div className="device-info-cell">{returnObj?.data?.timeofLastKnownDeviceStatus}</div>
					</div>
				</div>
				)}
			</div>
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(QueryVPNInfoPage));